import axiosInstance from "../../axiosInstance";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
export const getStudentCourse = createAsyncThunk(
  "get/studentCourse",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/userCourseList", {
        params: payload,
      });
      return response.data;
    } catch (error) {
      console.log({ error });
      rejectWithValue(error.response.data);
    }
  }
);
const studentCourse = createSlice({
  name: "studentCourse",
  initialState: {
    course: [],
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(getStudentCourse.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getStudentCourse.fulfilled, (state, action) => {
      state.loading = false;
      state.course = action.payload;
    });
    builder.addCase(getStudentCourse.rejected, (state) => {
      state.loading = false;
    });
  },
});

export default studentCourse.reducer;
